import template   from './delete-vehicle.html'
import controller from './delete-vehicle.controller'

let component = {
  restrict: 'E',
  bindings: {
    onConfirm: '&'
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-garage/components/delete-vehicle/delete-vehicle.component.js